<template>
  <transition name="edit-fade" mode="out-in">
    <div class="columns partners-wrapper" v-if="!edit && !add" :key="'1'">
      <div class="column is-8 partners">
        <loader :loading="loading.list" :fixed="false"></loader>
        <div class="field filter">
          <p class="control has-icons-right">
            <input class="input" type="text" :placeholder="$resx('Global.Filter')" v-model="input">
            <span class="icon is-small is-right" @click.prevent="input = ''">
              <font-awesome-icon :icon="icons.delete" />
            </span>
          </p>
        </div>
        <ul class="partners-list items-list">
          <li v-for="(partner, idx_l) in filtered" :key="idx_l" @click="selectPartner(idx_l)" :class="{selected: selected === idx_l}">
            <div class="image">
              <img :src="$store.state.imgBase + partner.Image" />
            </div>
            <div class="name">
              {{ partner.ID + '. ' + getPartnerName(partner) }}
            </div>
          </li>
        </ul>
      </div>
      <div class="column is-4">
        <div class="buttons">
          <button class="button is-fullwidth" @click.prevent="addPartner">
            <span class="icon">
              <font-awesome-icon :icon="icons.add"/>
            </span>
            <span>{{ $resx("Buttons.Add") }}</span>
          </button>
          <button class="button is-fullwidth" :disabled="(selected > -1 ? false : 'disabled')" @click.prevent="edit = true, $emit('canClose', false), $store.commit('contentChanged', true)">
            <span class="icon">
              <font-awesome-icon :icon="icons.edit" />
            </span>
            <span>{{ $resx("Buttons.Edit") }}</span>
          </button>
          <button class="button is-fullwidth is-danger" :disabled="(selected > -1 ? false : 'disabled')" @click.prevent="deletePartner">
            <span class="icon">
              <font-awesome-icon :icon="icons.delete" />
            </span>
            <span>{{ $resx("Buttons.Delete") }}</span>
          </button>
        </div>
      </div>
    </div>
    <div class="columns form-wrapper" v-else :key="'2'">
      <loader :loading="loading.edit" :fixed="false"></loader>
      <form class="column is-8">
        <file-input :profile="'partner'" v-if="staticPartner.Image || staticPartner.Image === ''" :value.sync="staticPartner.Image" @complete="setImage" :disabledProfiles="['meta', 'inline', 'fullwidth', 'image', 'icon', 'header', 'avatar', 'theme']"></file-input>
        <div class="field">
          <label class="label">{{ $resx("Partners.Link") }}</label>
          <div class="control">
            <input class="input" type="text" ref="partnerLink" v-bind:value="staticPartner.Link" v-on:input="staticPartner.Link = $event.target.value" />
          </div>
        </div>
        <div class="tabs">
          <ul>
            <li :class="{'is-active': tabCulture === key}" v-for="(culture, key) in $store.state.cultures" :key="key">
              <a @click.prevent="tabCulture = key">
                <span class="icon" :class="['flag flag-xs flag-'+key.split('-')[1].toLowerCase()]"></span>
              </a>
            </li>
          </ul>
        </div>
        <transition name="tab-fade" mode="out-in">
          <div v-if="tabCulture != ''" :key="tabCulture">
            <div class="field">
              <label class="label">{{ $resx("Partners.Name") }}</label>
              <div class="control">
                <input class="input" type="text" v-bind:value="(staticPartner.Cultures[tabCulture] ? staticPartner.Cultures[tabCulture].Name : '')" v-on:input="setValue('Name', $event.target.value)" />
              </div>
            </div>
            <div class="field">
              <label class="label">{{ $resx("Partners.Text") }}</label>
              <div class="control">
                <textarea class="textarea" v-bind:value="(staticPartner.Cultures[tabCulture] ? staticPartner.Cultures[tabCulture].Text : '')" v-on:input="setValue('Text', $event.target.value)"></textarea>
              </div>
            </div>
          </div>
        </transition>
      </form>
      <div class="column is-4">
        <div class="buttons">
          <button class="button is-fullwidth is-success" @click.prevent="submitPartner('submit')" :disabled="(submitEnabled ? false : 'disabled')">
            <span>{{ $resx("Buttons.Save") }}</span>
          </button>
          <button class="button is-fullwidth" @click.prevent="submitPartner('cancel')">
            <span>{{ $resx("Buttons.Cancel") }}</span>
          </button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>

import fileInput from '@/components/admin/FileInput.vue'
import { faToggleOn, faToggleOff, faPlus, faPencil, faTimes, faTrashAlt } from '@fortawesome/pro-regular-svg-icons'
import { getFilenameFromUrl } from '@/mixins/getFilenameFromUrl.js'
import { confirm } from '@/mixins/confirm.js'
import loader from '@/components/Loader.vue'

export default {
  name: 'modalContentPartners',
  data () {
    return {
      loading: {
        list: false,
        edit: false
      },
      selected: -1,
      input: '',
      icons: {
        toggleOn: faToggleOn,
        toggleOff: faToggleOff,
        add: faPlus,
        edit: faPencil,
        delete: faTimes,
        trash: faTrashAlt
      },
      add: false,
      edit: false,
      staticPartner: false,
      tabCulture: '',
      availableCultures: {},
      selectedForDelete: [],
      templates: {
        Partner: {
          ID: false,
          Image: '',
          Link: '',
          Cultures: {}
        }
      }
    }
  },
  mixins: [confirm, getFilenameFromUrl],
  components: {
    loader,
    fileInput
  },
  computed: {
    allPartners: {
      get () {
        return this.$store.state.partners
      }
    },
    submitEnabled () {
      if (this.add) {
        return this.staticPartner.Image !== ''
      } else {
        return this.staticPartner.Image !== '' && !(JSON.stringify(this.staticPartner) === JSON.stringify(this.filtered[this.selected]))
      }
    },
    selectedPartner () {
      if (this.selected > -1) { return this.filtered[this.selected] } else { return false }
    },
    filtered () {
      var filtered = []; var self = this
      self.$store.state.partners.forEach(partner => {
        if (self.input === '' || partner.Link.toLowerCase().indexOf(self.input.toLowerCase()) > -1) {
          filtered.push(partner)
        }
      })
      self.unselectPartner()
      return filtered
    },
    dragOptions () {
      return {
        animation: 200,
        group: 'description',
        disabled: false,
        ghostClass: 'ghost'
      }
    }
  },
  methods: {
    getCulture: function (partner) {
      var self = this
      var keys = Object.keys(partner.Cultures)
      if (keys.length === 0) {
        return {}
      } else if (partner.Cultures.hasOwnProperty(self.$store.state.language)) {
        return self.$store.state.language
      } else {
        return keys[0]
      }
    },
    getPartnerName: function (partner) {
      var self = this
      var culture = self.getCulture(partner)
      if (Object.keys(culture).length === 0) {
        return partner.Link
      } else {
        return partner.Cultures[culture].Name
      }
    },
    setValue: function (target, value) {
      var self = this
      var tmp = JSON.parse(JSON.stringify(self.staticPartner))
      if (!tmp.Cultures.hasOwnProperty(self.tabCulture)) {
        tmp.Cultures[self.tabCulture] = {
          Name: '',
          Text: ''
        }
      }
      tmp.Cultures[self.tabCulture][target] = value

      if (tmp.Cultures[self.tabCulture].Name === '' && tmp.Cultures[self.tabCulture].Text === '') {
        delete tmp.Cultures[self.tabCulture]
      }
      self.staticPartner = tmp
    },
    unselectPartner: function () {
      this.selected = -1
    },
    setImage: function (data) {
      var self = this
      self.staticPartner.Image = data.url
    },
    selectPartner: function (idx) {
      if (this.selected === idx) {
        this.tabCulture = ''
        this.selected = -1
        this.staticPartner = false
      } else {
        this.selected = idx
        this.tabCulture = Object.keys(this.selectedPartner.Cultures)[0] || Object.keys(this.$store.state.cultures)[0]
        this.staticPartner = JSON.parse(JSON.stringify(this.selectedPartner))
      }
    },
    addPartner: function () {
      var self = this
      var tmp = JSON.parse(JSON.stringify(self.templates.Partner))
      self.staticPartner = tmp
      self.tabCulture = Object.keys(self.$store.state.cultures)[0]
      self.add = true
      self.$emit('canClose', false)
      self.$store.commit('contentChanged', true)
    },
    deleteImage: function (canceled) {
      var self = this; var newObj; var oldObj
      if (canceled) {
        oldObj = self.staticPartner
        newObj = self.filtered[self.selected]
      } else {
        oldObj = self.filtered[self.selected]
        newObj = self.staticPartner
      }
      if (oldObj && newObj && self.submitEnabled && oldObj.Image !== '' && newObj.Image !== oldObj.Image) {
        var file = self.getFilenameFromUrl(oldObj.Image)
        self.$store.dispatch('deleteFile', file)
      }
    },
    deletePartner: function () {
      var self = this; var message
      if (self.selected > -1) {
        message = self.$resx('Global.AreYouSure')
        self.confirm({
          message: message,
          buttons: [
            {
              name: self.$resx('Buttons.Cancel'),
              class: 'is-pulled-left'
            },
            {
              name: self.$resx('Buttons.Delete'),
              class: 'is-pulled-right is-danger',
              action: function () {
                self.loading.list = true
                var partner = self.filtered[self.selected].ID
                self.$http({
                  method: 'DELETE',
                  url: '/partner/' + partner,
                  name: process.env.VUE_APP_NAME + '_' + self.$store.state.language,
                  api: 'website'
                }).then(function (response) {
                  self.$store.dispatch('getSitemap', true).then(function () {
                    self.$store.dispatch('setSnack', {
                      message: self.$resx('Partners.Removed')
                    })
                    self.selected = -1
                    self.loading.list = false
                  })
                }).catch(function (err) {
                  self.$store.dispatch('setSnack', {
                    message: err.message
                  })
                  self.selected = -1
                  self.loading.list = false
                })
              }
            }
          ]
        })
      }
    },
    resetSelected: function () {
      var self = this
      self.staticPartner = false
      self.selected = -1
      self.add = false
      self.edit = false
      self.$emit('canClose', true)
      self.$store.commit('contentChanged', false)
    },
    submitPartner: function (action) {
      var self = this
      if (action === 'submit') {
        // save header
        self.loading.edit = true
        var method = 'PUT'
        if (self.add) {
          method = 'POST'
          delete self.staticPartner.ID
        }
        self.$http({
          method: method,
          url: '/partner',
          api: 'website',
          data: self.staticPartner,
          name: process.env.VUE_APP_NAME + '_' + self.$store.state.language
        }).then(function (response) {
          self.deleteImage(false)
          self.$store.dispatch('getSitemap', true).then(function () {
            self.$store.dispatch('setSnack', {
              message: self.$resx('Partners.Saved')
            })
            self.loading.edit = false
            self.resetSelected()
          })
        }).catch(function (err) {
          self.$store.dispatch('setSnack', {
            message: err.message
          })
          self.loading.edit = false
          self.resetSelected()
        })
      } else {
        self.deleteImage(true)
        self.loading.edit = false
        self.resetSelected()
      }
    }
  },
  created () {
    var self = this
    self.$store.dispatch('getAvailableCultures').then(function (cultures) {
      self.availableCultures = cultures
    })
  }
}
</script>

<style lang="scss" scoped>

.edit-fade-enter-active,
.edit-fade-leave-active,
.tab-fade-enter-active,
.tab-fade-leave-active {
  transition: opacity 0.2s;
}
.edit-fade-enter,
.edit-fade-leave-to,
.tab-fade-enter,
.tab-fade-leave-to {
  opacity: 0;
}
.flip-list-move {
  transition: transform 0.5s;
}
.ghost {
  opacity: 0.3;
}

.partners-wrapper{
  height: 450px;

  .partners{
    .filter{
      display: inline-block;
      vertical-align: top;
      width: 100%;
      margin-right: 10px;
      margin-bottom: 0;

      .control{
        .icon{
          pointer-events: all;
          cursor: pointer !important;
        }
      }
    }

    .partners-list{
      // height: 380px;
      // overflow: auto;
      // margin-top: 10px;

      li{

        // display: inline-block;
        // width: 100%;
        // &.group{
        //   pointer-events: none;
        //   height: 20px;
        //   font-size: 0.9em;
        // }
        // &:not(.group){
        //   height: 50px;
        //   border: 1px solid $grey-lighter;
        //   background-color: $grey-bg;
        //   border-radius: 4px;
        //   padding: 10px 20px;
        //   line-height: 30px;
        //   cursor: pointer;

        //   + li{
        //     margin-top: 10px;
        //   }

        //   &.selected{
        //     border-color: $grey;
        //   }
          .name{
            display: inline-block;
            vertical-align: top;
            width: calc(100% - 50px);
            @include text-overflow;
          }
          .image{
            display: inline-block;
            vertical-align: top;
            width: 40px;
            height: 40px;
            margin-top: -5px;
            margin-right: 10px;

            img{
              max-height: 100%;
              max-width: 100%;
              width: auto;
              height: auto;
              vertical-align: bottom;
              display: inline-block;
            }
          }
        }
      // }
    }
  }
}
.form-wrapper{
  >.is-8{
    height: 450px;
    overflow: auto;

    .input-div{
      display: block;
      flex: 1;
      cursor: pointer;
      -webkit-box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.1);
      box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.1);
      background-color: #fcfdfd;
      border-radius: 4px 0px 0px 4px;
      align-items: center;
      border: 1px solid #dbdbdb;
      height: 2.25em;
      justify-content: flex-start;
      line-height: 1.5;
      padding-bottom: calc(0.375em - 1px);
      padding-left: 2.25em;
      padding-right: calc(0.625em - 1px);
      padding-top: calc(0.375em - 1px);
      position: relative;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;

      input{
        position: absolute;
        left: 0;
        opacity: 0;
        top: 0;
        bottom: 0;
        width: 100%;
        z-index: -1;
        cursor: pointer;
      }
    }
  }

  .field{
    &.cultures{
      .radio{
        + .radio{
          margin-left: 15px;
        }
        .icon{
          margin: 0px 5px -7px 5px;
          vertical-align: unset;
        }
      }
    }
  }
}
</style>
